import React from 'react';
import { render } from 'react-dom';
import GrooveButton from './GrooveButton';
import loadGroove from './vendor/loadGroove';

import styles from './GrooveWidget.module.scss';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    groove: any;
  }
}

export default class GrooveManager {
  private static instance: GrooveManager;
  private GROOVE_ID: string;
  private static DEFAULT_GROOVE_ID = '2cf89baf-66cb-4e8e-811e-ee4c49b61527';
  private static DET_GROOVE_ID = '0531ac7e-99d3-4b3f-ae3b-08955788b689';

  public detVariant: boolean;
  public isOpen: boolean;
  private listeners: ((isOpen: boolean) => void)[];

  private constructor(detVariant = false) {
    this.isOpen = false;
    this.listeners = [];
    this.detVariant = detVariant;
    this.GROOVE_ID = detVariant
      ? GrooveManager.DET_GROOVE_ID
      : GrooveManager.DEFAULT_GROOVE_ID;
  }

  public static getInstance(detVariant = false): GrooveManager {
    if (
      !GrooveManager.instance ||
      GrooveManager.instance.detVariant != detVariant
    ) {
      GrooveManager.instance = new GrooveManager(detVariant);
    }

    return GrooveManager.instance;
  }

  public isActive(): boolean {
    return (
      !!window.groove &&
      !!document.querySelector(`#groove-container-${this.GROOVE_ID}`)
    );
  }

  public init(): void {
    loadGroove(this.GROOVE_ID);

    window.groove.widget = window.groove.createWidget();
    window.groove.widget.init(this.GROOVE_ID, {});
    window.groove.widget.onload = () => {
      this.loadGroove();
      this.initReact();
      window.groove.widget.onload = null;
    };
  }

  private loadGroove() {
    const grooveContainer = document.querySelector(
      `#groove-container-${this.GROOVE_ID}`
    );
    grooveContainer?.classList.add('groove-container');
    window.addEventListener('message', () => {
      const prevState = this.isOpen;
      this.isOpen = window.groove.widget.shim.isOpen;
      if (prevState != this.isOpen)
        this.listeners.forEach((fn) => fn(this.isOpen));
    });

    window.addEventListener('click', () => {
      // Doesn't trigger on iframe clicks, so doesn't affect the widget
      if (this.isOpen) this.setOpen(false);
    });

    const grooveOuterContainer =
      document.querySelector('.groove-outer-container') ||
      this.createGrooveOuterContainer();

    grooveOuterContainer?.appendChild(grooveContainer as Node);
  }

  private initReact() {
    const grooveContainer = document.querySelector(
      `#groove-container-${this.GROOVE_ID}`
    );
    const reactRoot = document.createElement('div');
    reactRoot.classList.add(
      this.detVariant ? styles.templateContainer : styles.widgetContainer
    );
    grooveContainer?.prepend(reactRoot);

    render(<GrooveButton grooveManager={this} />, reactRoot);
  }

  public addListener(listener: (isOpen: boolean) => void) {
    this.listeners.push(listener);
  }

  public setOpen(isOpen: boolean): void {
    window.groove?.widget?.toggle(isOpen);
  }

  // Create a container if the layout did not render one (defensive fallback)
  private createGrooveOuterContainer() {
    const grooveOuterContainer = document.createElement('div');
    grooveOuterContainer.className = 'groove-outer-container';
    document.body.appendChild(grooveOuterContainer);
    return grooveOuterContainer;
  }
}
